import { useWindowSize } from "react-use";
import theme from "../gatsby-plugin-theme-ui";

const useTrackWindowSize = () => {
  const { width, height } = useWindowSize();

  return {
    smallScreen: width && width < theme.responsive.mediumLarge,
    smallerScreen: width && width < theme.responsive.medium,
    smallScreenUp: width && width > theme.responsive.small,
    desktop: width && width > theme.responsive.mediumLarge,
    mobile: width && width < theme.responsive.small,
    tablet:
      width &&
      width >= theme.responsive.small &&
      width &&
      width < theme.responsive.large,
    largeDesktop: width && width > theme.responsive.large,
    windowSize: { width, height },
  };
};

export default useTrackWindowSize;
